var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',{staticClass:"red_bold"},[_vm._v(_vm._s(_vm.$t('strings.facilitator'))+": ")]),_c('em',{staticClass:"italic"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }